import { apiUrlPrefix } from '../../../config';
import Cookies from 'js-cookie';

// This is retrieving all the reports from users to an admin level
const fetchBlockedUsers = async () => {
    try {
        const rawUserId = localStorage.getItem('userId');
        const response = await fetch(
            `${apiUrlPrefix}Blocking/GetBlockedUsers?userId=${rawUserId}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.ok) {
            const data = await response.json();
            if (!data.includes("null")) {
                return data;
            }
            return data; // Return the data so your component can use it
        } else {
            console.error("Failed to fetch discussions");
        }
    } catch (error) {
        console.error("Error fetching discussions:", error);
    }
};

export default fetchBlockedUsers;